import type { FaireProductEntity } from "../../entity_types/product";

export const p_m4uahrzh7m: FaireProductEntity = {
  token: "p_m4uahrzh7m",
  type: "product",
  name: "6mm Round/SquareCut Crystal Cubic Zirconia CZ Stud Earrings",
  brandToken: "b_c3xmn96nkh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b7f3e37ca18e20077ff113782d596c69d9ef9e46d2dd473f9667e57dd7be5977.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b29cafca754f774876ff423e8608a24724bff70d9688246038eddeb8d563cc31.jpeg",
    "https://cdn.faire.com/fastly/4d129441ff5aca36df139b18b018281be45c5b8849df6773a1b33912f2b12475.jpeg",
    "https://cdn.faire.com/fastly/e5229ae891b70106ea8103994a3d5925e32b10cb6db7a435e81dc194b434f34f.jpeg",
    "https://cdn.faire.com/fastly/956791631366eca9fcbdfbb5140f06914dda1f0262274d1775cb666eea5238f4.jpeg",
    "https://cdn.faire.com/fastly/c9ab7cbfe46a904740e842d6bfc3fbd2299bbd3e670735af84a22c6df0b141e2.jpeg",
    "https://cdn.faire.com/fastly/a6b849007817cbfa727c41ff723c95c31b92d7151f062c287c43d7a581ce8f9e.jpeg",
    "https://cdn.faire.com/fastly/3ddff7449a6193e2c5f3ce0ca22fae20c4ca229f7ec3026b8607e73c86b3d213.jpeg",
  ],
  priceDollars: 4.58,
  description:
    "6mm Round/SquareCut Crystal Cubic Zirconia CZ Stud Earrings\n• Size : 6mm \n• Post Back\n• CZ Cubic Zirconia",
  tags: [],
  msrpDollars: 9.15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:01.550Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
